
export const COMPANY_INFO = {
  name: 'ChartTower Corp',
  email: 'info@ctc-corp.eu',
  location: 'Estonia, Tallinn',
  social: {
    twitter: 'https://x.com/ChartTowerCorp',
    telegram: 'https://t.me/+k7im9T6EcR9iNDY0', // Gateway principale (Corporate Group)
    telegramToken: 'https://t.me/ChartTowerCorp_CTC_Official',
    instagram: 'https://www.instagram.com/charttowercorp/',
    linkedin: '#'
  }
};

export const ROUTES = {
  HOME: '/',
  FINANCE: '/finance',
  BLUE_STRIKE: '/services/blue-strike',
  BLUE_STRIKE_DASHBOARD: '/blue-strike-dashboard',
  ALGO_ENGINE: '/services/algo-engine',
  ALGO_ENGINE_DASHBOARD: '/algo-engine-dashboard',
  COPY_SERVICE: '/services/copy-service',
  REAL_ESTATE: '/real-estate',
  TOKEN: '/token',
  CORPORATE_INFO: '/corporate-info',
  WHITEPAPER: '/whitepaper',
  AI_AUTOMATION: '/ai-automation',
  LINKTREE: '/links',
  PRIVACY: '/privacy-policy',
  COOKIE: '/cookie-policy',
  TERMS: '/terms-of-service'
};

// SOSTITUISCI QUI I LINK DELLE IMMAGINI DEI LOGHI
export const ASSETS = {
  // Logo usato in Navbar, Footer, Corporate Info, Home (Il grafico con barre - SENZA sfondo)
  LOGO_COMPANY: '/logo-company.png',

  // Logo usato ESCLUSIVAMENTE nella Token Page (La moneta/coin con bordo blu)
  LOGO_TOKEN: '/logo-token.png',
};

// LINK AI DOCUMENTI PDF - SOSTITUIRE CON I LINK REALI
export const DOCUMENTS = {
  // White Paper
  WHITEPAPER_LATEST: '/documents/CTC_White_Paper_v5_ENG.pdf',
  WHITEPAPER_ARCHIVE: [
    { version: 'v4', date: '2025-08-01', url: '#' },
    { version: 'v3', date: '2025-07-15', url: '#' }
  ],

  // Blue Strike Backtest & Listino
  BLUE_STRIKE_PRICELIST_IT: '/documents/IT CTC Blue Strike.pdf',
  BLUE_STRIKE_PRICELIST_EN: '/documents/ENG CTC Blue Strike.pdf',

  // Algo Engine Listino
  ALGO_ENGINE_PRICELIST_IT: '/documents/IT CTC Algo Engine 2.0.pdf',
  ALGO_ENGINE_PRICELIST_EN: '/documents/ENG CTC Algo Engine 2.0.pdf'
};

export const EXTERNAL_LINKS = {
  TELEGRAM_ACCESS: 'https://t.me/+k7im9T6EcR9iNDY0', // Official Corporate Group (Access with request)
  TELEGRAM_TOKEN_CHANNEL: 'https://t.me/ChartTowerCorp_CTC_Official', // Official Token Channel
  TELEGRAM_TOKEN_COMMUNITY: 'https://t.me/CTC_Token_Community', // Token Community Group
  RAYDIUM_SWAP: 'https://raydium.io/swap/?inputMint=CTCNkcqpbxMTTRdvAyhzhUUSLbYLBFEnDgyr5zs4hWxX&outputMint=EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
  BLUE_STRIKE_PRESENTATION: 'https://www.canva.com/design/DAG4nrYHyjo/8uCQxJZtUE51Dw0h1cXW1g/view?utm_content=DAG4nrYHyjo&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h3bcdb4ad94',
  MYFXBOOK_BLUE_STRIKE: 'https://www.myfxbook.com/portfolio/ctc-blue-strike-5k/11752602',
  TRUSTPILOT: '#' // Link Trustpilot generale
};

// CONFIGURAZIONE RECENSIONI E SCREENSHOT
// Qui puoi aggiungere gli screenshot di MT4 (type: 'image') o le recensioni testuali (type: 'review')
export const SERVICE_REVIEWS = {
  BLUE_STRIKE: [
    {
      type: 'image',
      src: 'https://images.unsplash.com/photo-1611974765270-ca1258634369?auto=format&fit=crop&q=80&w=1000', // Sostituire con screen MT4 reale
      caption: 'Profitto Settimanale XAUUSD (+4.2%)',
      date: 'Nov 2025'
    },
    {
      type: 'review',
      author: 'Alessandro M.',
      rating: 5,
      text: 'Utilizzo Blue Strike da 3 mesi. La gestione del rischio durante le news è impressionante. Mai visto un DD così basso.',
      source: 'Telegram Chat'
    },
    {
      type: 'image',
      src: 'https://images.unsplash.com/photo-1642543492481-44e81e3914a7?auto=format&fit=crop&q=80&w=1000', // Sostituire con screen MyFXBook/MT4
      caption: 'Chiusura Mensile Ottobre',
      date: 'Oct 2025'
    },
    {
      type: 'review',
      author: 'Giuseppe R.',
      rating: 5,
      text: 'Finalmente un EA che non brucia il conto. Assistenza top nel gruppo corporate.',
      source: 'Trustpilot'
    }
  ],
  ALGO_ENGINE: [
    {
      type: 'review',
      author: 'Luca B.',
      rating: 5,
      text: 'I segnali su Telegram sono precisi. Ottimo il report PDF a fine mese per capire dove migliorare.',
      source: 'Telegram Community'
    },
    {
      type: 'image',
      src: 'https://images.unsplash.com/photo-1640340434855-6084b1f4901c?auto=format&fit=crop&q=80&w=1000', // Sostituire con screen Grafico Analisi
      caption: 'Analisi Tecnica US30 - Target Raggiunto',
      date: '12 Nov 2025'
    },
    {
      type: 'review',
      author: 'Elena V.',
      rating: 4,
      text: 'La dashboard è utilissima. Seguo i segnali anche da mobile senza problemi.',
      source: 'Direct Feedback'
    }
  ],
  COPY_SERVICE: [
    {
      type: 'image',
      src: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=1000', // Sostituire con screen App Mobile
      caption: 'Replica su Mobile - Latenza Zero',
      date: 'Live'
    },
    {
      type: 'review',
      author: 'Marco T.',
      rating: 5,
      text: 'Zero stress. Ho collegato il conto e fa tutto lui. Trasparenza assoluta sulle fee.',
      source: 'Trustpilot'
    },
    {
      type: 'image',
      src: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?auto=format&fit=crop&q=80&w=1000', // Sostituire con screen Dashboard
      caption: 'Performance YTD (+22%)',
      date: '2025'
    }
  ]
};
